import { confirmPasswordSchema, createPasswordSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const resetPassSchema = object().shape({
  password: createPasswordSchema, 
  confirmPassword: confirmPasswordSchema(),
});

export default resetPassSchema;